<template>
  <div>
    <datatable :columns="columns" :scroll-x="false">
      <template #tbody="{ classes }">
        <tr v-for="(productRequirement, index) in productRequirements" :key="index" :class="[classes.tr]">
          <td
            :class="[classes.td, 'relative']"
          >
            <input
              type="text"
              class="block border-0 p-0 placeholder-gray-200 focus:ring-0 sm:text-sm"
              placeholder="Kode barang"
              @change="onSearchProduct(index)"
              v-model="productRequirements[index].searchProduct"
            />
            <button
              type="button"
              class="absolute inset-y-0 top-0 right-0 flex cursor-pointer items-center pl-3"
              @click="onOpenProductModal(index)"
            >
              <Icon
                class="h-5 w-5 text-gray-500 hover:text-gray-700"
                icon="heroicons:magnifying-glass-circle-20-solid"
              />
            </button>
          </td>
          <td :class="classes.td">
            {{ productRequirement.productName }}
          </td>
          <td v-if="!quantityProduct" :class="[classes.td, 'w-52']">
            <input
              v-if="productRequirement.id"
              type="text"
              name="kode_barang"
              class="block w-full border-0 p-0 placeholder-gray-200 focus:ring-0 sm:text-sm"
              placeholder="Jumlah"
              v-model="productRequirements[index].inputMinQty"
              @change="onChangeMinQty(index)"
            />
          </td>
          <td :class="[classes.td, 'w-10']">
            <base-button
              v-if="productRequirement.id"
              type="button"
              class="text-red-300 hover:text-red-600"
              tabindex="-1"
              for-icon
              @click="onDelete(index)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 cursor-pointer"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </base-button>
          </td>
        </tr>
      </template>
    </datatable>
    <teleport to="body">
      <product-modal
        :visible="productModal.visible"
        @page-change="onProductModalChangePage"
        @change="onProductModalChangeProduct"
        @search="onProductModalSearchProduct"
        @close="productModal.visible = false"
      />
    </teleport>
    <teleport to="body">
      <loading v-if="loading" />
    </teleport>
  </div>
</template>

<script>
import { requestMixin } from '@/mixins/request/request'
import { mapActions } from 'vuex';
import ProductModal from '@/components/modal/product-modal.vue';
import Teleport from 'vue2-teleport';

export default {
  mixins: [requestMixin],
  components: { ProductModal, Teleport },
  props: {
    productBundle: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      productModal: {
        visible: false,
        search: null
      },
      productRequirements: [
        {
          searchProduct: null,
          productName: null
        }
      ]
    }
  },
  computed: {
    columns() {
      return [
        { id: 'code', name: 'Kode Barang' },
        { id: 'name', name: 'Nama Barang' },
        !this.quantityProduct ? { id: 'min_qty', name: 'Jumlah Minimal' } : null,
        { id: 'action', name: 'Aksi' }
      ].filter(item => !!item);
    },
    multipleProduct() {
      return this.productBundle.data.attributes.requirement_type === 'multiple'
    },
    quantityProduct() {
      return this.productBundle.data.attributes.using_min_qty
    }
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
      fetchProducts: 'products/fetchProducts',
    }),
    addEmptyProduct() {
      this.productRequirements.push({     
        id: null,   
        productCode: null,
        productName: null,
        minQty: null,
        searchProduct: null,
        inputMinQty: null
      })
    },
    async createProductRequirement(product) {
      return await this.request('/api/v1/product-bundle-requirements', {
        method: 'post',
        data: {
          data: {
            type: 'product-bundle-requirements',
            attributes: {},
            relationships: {
              'product-bundle': {
                data: {
                  type: 'product-bundles',
                  id: this.productBundle.data.id
                }
              },
              product: {
                data: {
                  type: 'products',
                  id: product.id
                }
              }
            }
          }
        }
      })
    },
    async loadProductModal(params = {}) {
      this.loading = true

      await this.fetchProducts({
        'page[size]': 5,
        'filter[search]': this.productModal.search,
        'include': 'product-category,unit',
        ...params
      })

      this.loading = false
    },
    async onChangeMinQty(index) {
      this.loading = true

      const productRequirement = this.productRequirements[index]

      const [, error] = await this.request(`/api/v1/product-bundle-requirements/${productRequirement.id}`, {
        method: 'patch',
        data: {
          data: {
            type: 'product-bundle-requirements',
            id: productRequirement.id,
            attributes: {
              min_qty: parseInt(productRequirement.inputMinQty)
            }
          }
        }
      })

      if (error) {
        this.createAlert({
          data: this.getRequestErrorMessage(error),
          status: 'error',
          type: 'confirm'
        });

        this.productRequirements[index].inputMinQty = productRequirement.minQty
      } else {
        this.productRequirements[index].minQty = productRequirement.inputMinQty
      }

      this.loading = false
    },
    async onDelete(index) {
      this.loading = true

      const productRequirement = this.productRequirements[index]

      const [, error] = await this.request(`/api/v1/product-bundle-requirements/${productRequirement.id}`, {
        method: 'delete'
      })

      if (error) {
        this.createAlert({
          data: this.getRequestErrorMessage(error),
          status: 'error',
          type: 'confirm'
        });
      } else {
        this.productRequirements.splice(index, 1)

        if (!this.multipleProduct) {
          this.addEmptyProduct()
        }
      }

      this.loading = false
    },
    onOpenProductModal(index) {
      this.productModal.search = null
      this.productModal.index = index
      this.productModal.visible = true

      this.loadProductModal()
    },
    onProductModalChangePage(page) {
      this.loadProductModal({
        'page[number]': page
      })
    },
    onProductModalSearchProduct(q) {
      this.productModal.search = q

      this.loadProductModal()
    },
    async onProductModalChangeProduct(product) {
      this.productRequirements[this.productModal.index].searchProduct = product.attributes.code

      const [res] = await this.storeProduct(product, this.productModal.index)

      if (res) {
        this.productModal.visible = false
      }
    },
    async onSearchProduct(index) {
      this.loading = true

      const products = await this.fetchProducts({
        'page[size]': 1,
        'filter[search]': this.productRequirements[index].searchProduct,
        'include': ''
      })

      if (products && products.data.data.length) {
        const product = products.data.data[0]

        await this.storeProduct(product, index)
      } else {
        this.productRequirements[index].searchProduct = this.productRequirements[index].productCode
      }

      this.loading = false
    },
    setProductRequirements() {
      this.productRequirements = this.getIncludedByType(this.productBundle, 'product-bundle-requirements')
        .map(requirement => ({
          id: requirement.id,
          productCode: requirement.attributes.product_code,
          productName: requirement.attributes.product_name,
          minQty: requirement.attributes.min_qty,
          searchProduct: requirement.attributes.product_code,
          inputMinQty: requirement.attributes.min_qty,
        }))
      
      if (this.multipleProduct || !this.productRequirements.length) {
        this.addEmptyProduct()
      }
    },
    setProductRequirement(product, index) {
      this.productRequirements[index].id = product.data.id
      this.productRequirements[index].productCode = this.productRequirements[index].searchProduct
      this.productRequirements[index].productName = product.data.attributes.product_name
    },
    async storeProduct(product, index) {
      this.loading = true

      const productRequirement = this.productRequirements[index]

      const [res, error] = productRequirement.id ? await this.updateProductRequirement(product, index) : await this.createProductRequirement(product, index)

      if (error) {
        this.createAlert({
          data: this.getRequestErrorMessage(error),
          status: 'error',
          type: 'confirm'
        });

        this.productRequirements[index].searchProduct = productRequirement.productCode
      } else {
        this.setProductRequirement(res, index)
        
        if (this.multipleProduct && index === this.productRequirements.length - 1) {
          this.addEmptyProduct()
        }
      }

      this.loading = false

      return [res, error]
    },
    async updateProductRequirement(product, index) {
      const productRequirement = this.productRequirements[index]

      return await this.request(`/api/v1/product-bundle-requirements/${productRequirement.id}`, {
        method: 'patch',
        data: {
          data: {
            type: 'product-bundle-requirements',
            id: productRequirement.id,
            attributes: {},
            relationships: {
              product: {
                data: {
                  type: 'products',
                  id: product.id
                }
              }
            }
          }
        }
      })
    },
  },
  created() {
    this.setProductRequirements()
  }
}
</script>
